<template>
  <div class="product__info">
    <a class="product__title-link" :href="product.onlineStoreUrl">
      <h2 class="product__title">{{ product.title }}</h2>
    </a>

    <button class="add-to-bag__button" @click="handleAddToBag">
      <template v-if="showAddToBag">
        Add to bag | {{ formattedPrice }}
        <template v-if="isOnSale">
          <span class="product__price-onsale">{{ formattedSalePrice }}</span>
        </template>
      </template>
      <template v-else>Notify me</template>
    </button>
    <div v-if="isOnSale" class="product__onsale">SALE</div>
  </div>
</template>

<script>
import { unwrapNodes } from "@/helpers/graphql";
import { mapActions } from "vuex";

export default {
  name: "InfoActions",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    price() {
      return this.product.priceRange.minVariantPrice;
    },
    originalPrice() {
      return this.product.compareAtPriceRange.minVariantPrice;
    },
    isOnSale() {
      return (
        parseFloat(this.originalPrice.amount) > parseFloat(this.price.amount)
      );
    },
    showAddToBag() {
      const hasMultipleVariants =
        unwrapNodes(this.product.variants.edges).length > 1;
      const isAvailableForSale = this.product.availableForSale;
      return hasMultipleVariants || isAvailableForSale;
    },
    formattedPrice() {
      return this.formatCurrency(this.price);
    },
    formattedSalePrice() {
      return this.formatCurrency(this.originalPrice);
    },
  },
  methods: {
    ...mapActions("add-to-bag", ["openAddToBag"]),
    handleAddToBag() {
      this.openAddToBag(this.product);
    },
    formatCurrency({ amount, currencyCode }) {
      return this.$filters.toCurrency(amount, currencyCode, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.product__info {
  padding: 10px 10px 40px 10px;

  @include respond-above(md) {
    padding: 10px 10px 40px 0;
  }

  a {
    text-decoration: none;
    color: $color-dark;
  }

  .product__onsale {
    color: #070707;
    font-size: 11px;
    margin: 5px 0 0 0;
    opacity: 0.6;
  }

  .product__price-onsale {
    text-decoration: line-through;
  }
}

.product__title {
  font-family: $heading-font-family;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  @include respond-above(md) {
    @include t__editorial-label-10;
  }
}

.add-to-bag__button {
  outline: none;
  background: none;
  border: none;
  padding: 0;
  @include t__utility-label-20;
}
</style>
